import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API } from '@app-core/constants/api.constants';
import { setParams } from '@app-core/models/core.model';
import { GetBucketContentParams } from '@app-diagnostics/common/diagnostics.model';

@Injectable({
  providedIn: 'root',
})
export class DiagnosticsService {
  constructor(private http: HttpClient) {}

  public getBucketData(param: GetBucketContentParams): Observable<any> {
    const httpOptions = {
      params: setParams(param),
    };
    return this.http.get(API.GET_BUCKET_CONTENT, httpOptions);
  }
}
